import { CreditCard } from './credit-card';
import { DirectDebit } from './direct-debit';
import { Paypal } from './paypal';
import { TeamBudget } from './team-budget';

export type ReusablePaymentMethod = CreditCard | DirectDebit | Paypal | TeamBudget;
